import { COLORS } from '@/constants/colors';
import { Link } from '@/config/i18n/navigation';
import styled from 'styled-components';

export const FooterWrapper = styled.footer<{ $hasStickyBar?: boolean }>`
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: ${({ $hasStickyBar }) => ($hasStickyBar ? '80px' : '36px')};
`;

export const FooterContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  background-color: #334c71;
  padding: 50px 0;
  position: relative;
`;

export const FooterCopyrightWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  background-color: #253a5a;
  padding: 15px 0;
`;

export const Container = styled.div`
  max-width: 1330px;
  margin: 0 auto;
  padding: 0 50px;
  display: flex;
  justify-content: space-between;
  gap: 20px;

  @media (max-width: 1020px) {
    flex-direction: column;
  }
`;

export const LinkStyled = styled(Link)`
  color: ${COLORS['gray-light']};
`;

export const LogoBlock = styled.div`
  width: 230px;
  height: 38px;
  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
`;

export const AdditionalNavigation = styled.nav`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 60px;
  row-gap: 0px;
  min-height: 90px;

  @media (max-width: 1020px) {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
    min-height: 120px;
  }
  @media (max-width: 460px) {
    grid-template-columns: repeat(1, 1fr);
    min-height: 210px;
  }
`;

export const FollowUsLinks = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const FollowUsBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
`;

export const VersionContent = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 1330px;
  padding: 6px 0;
  width: 100%;
  font-weight: 600;
  font-size: 16px;
`;
